import { Component } from '@angular/core';
import { UserProfileService } from '../service/user-profile.service';
import { AchievementService } from '../service/achievement.service';
import { MatListModule } from '@angular/material/list';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CommonModule } from '@angular/common';
import { ThemePalette } from '@angular/material/core';
import { TranslateService } from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
import { Location } from '@angular/common';
@Component({
  selector: 'app-milestone',
  standalone: true,
  imports: [
    MatListModule,
    MatExpansionModule,
    MatToolbarModule,
    MatIconModule,
    RouterLink,
    MatCardModule,
    MatProgressSpinnerModule,
    CommonModule,
    TranslateModule,
  ],
  templateUrl: './milestone.component.html',
  styleUrl: './milestone.component.css'
})
export class MilestoneComponent {
  color : ThemePalette = 'accent';
  isLoading = false;
  apexId!:string;
  achievementIdObjectMap!:Map<string,any>;
  milestoneObjectArray!:any[];
  constructor(
    private userProfileService: UserProfileService,
    private achievementService: AchievementService,
    public translate: TranslateService,
    private location: Location,
  ) { 
    translate.setDefaultLang('en');
    let browserLangToUse = '';
    let browserLang = translate.getBrowserCultureLang();
    browserLangToUse = browserLang === undefined ? 'en' : browserLang;
    translate.use(browserLangToUse);
  }
  ngOnInit(): void {
    this.isLoading = true;
    let overrideObjectString = localStorage.getItem("overrideObject");
    if(overrideObjectString === null){
      let apexId = localStorage.getItem("apexid");
      if(apexId !== null){
        // this.apexId = apexId;
        this.pageInitialization(apexId);
      }
    }
    else{
      let overrideObject = JSON.parse(overrideObjectString);
      let apexId = overrideObject.apexid;
      this.pageInitialization(apexId);
    }
  }
  private pageInitialization(apexId:string): void {
    this.achievementIdObjectMap = new Map();
    this.achievementService.getMilestoneByApexId(apexId).subscribe(responseMilestoneObjectArray => {
      this.milestoneObjectArray = responseMilestoneObjectArray;
      for (const milestoneObject of this.milestoneObjectArray){
        let key = milestoneObject.achievementId;
        if(this.achievementIdObjectMap.has(key)){
          let groupedMilestone = this.achievementIdObjectMap.get(key);
          groupedMilestone.milestoneArray.push(milestoneObject);
          this.achievementIdObjectMap.set(key, groupedMilestone);
        }
        else{
          let newMilestoneArray = [];
          newMilestoneArray.push(milestoneObject);
          let groupedMilestone : any = { achievementId:milestoneObject.achievementId, 
            achievementName:milestoneObject.achievementName, 
            achievement_Translation_Id:milestoneObject.achievement_Translation_Id, 
            milestoneArray: newMilestoneArray };
          this.achievementIdObjectMap.set(key, groupedMilestone);
        }
      }
      this.isLoading = false;
    });
  }
  formatDate(dateString:string): string{
    return new Date(dateString).toLocaleString();
  }
  backClicked() {
    this.location.back();
  }
}
